import catalog from "./hermesSkillCatalog.json";
import { categorizeSkill, STOCK_HERMES_SKILLS } from "./skillTaxonomy";

// The published origin is authoritative. A brand skill named "pdf" must not
// inherit the stock PDF skill's description, category, or capabilities.
export function hermesSkillDetails(skill) {
  if (categorizeSkill(skill) !== STOCK_HERMES_SKILLS) return null;
  const name = String(skill?.name || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
  return Object.hasOwn(catalog.skills, name) ? catalog.skills[name] : null;
}

export function usesHermesDescription(skill) {
  return (
    !String(skill?.description || "").trim() && !!hermesSkillDetails(skill)
  );
}

// Catalog overviews are plain explanatory copy; display inline-code text without
// markdown delimiters. Never interpret skill instructions as executable content.
export const hermesReferenceText = (value) =>
  String(value || "")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
